<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar dense class="toolbar" flat>
                <v-toolbar-title>Partial Salary Calculation</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row dense justify="center">
                <v-col cols="12" md="4" class="pt-4">
                    <v-autocomplete rounded outlined dense v-model="year" :items="year_list" item-text="name" item-value="id" label="Select Year" @change="partialSalaryMonthData()" />
                </v-col>
                <v-col cols="12" md="4" class="pt-4" v-if="year">
                    <v-autocomplete rounded outlined dense v-model="sal_mon_id" :items="sal_month_list" item-text="name" item-value="id" label="Select Month" @change="partialSalaryMasterData()" />
                </v-col>
                <v-col cols="12" md="4" class="pt-4" v-if="sal_mon_id">
                    <v-autocomplete rounded outlined dense v-model="partial_salary_installment" :items="partial_salary_installment_list" item-text="ps_name" item-value="ps_id" label="Partial Installment Master" />
                </v-col>
                <v-col cols="12" sm="4" md="4" class="pt-4">
                    <v-autocomplete color="#0F2027" dense rounded required v-model="employee_type" :items="employee_type_list" item-text="name" item-value="id" label="Employee Type" outlined />
                </v-col>
                <v-col cols="12" sm="4" md="4" class="pt-4">
                    <v-autocomplete color="#0F2027" dense rounded required v-model="designation" :items="designation_list" item-text="name" item-value="id" label="Designation" outlined />
                </v-col>
                <v-col cols="12" md="4" class="pt-4">
                    <v-autocomplete rounded outlined dense v-model="empid" :items="employee_list" item-text="name" item-value="id" label="Select Employee" />
                </v-col>
                <v-col cols="12" md="2" class="pt-2">
                    <v-btn class="button"v-if="sal_mon_id && partial_salary_installment" @click="getPartialSalaryCalculation()">Fetch</v-btn>
                </v-col>
            </v-row>
            <v-row v-if="finalPartialRegisterArray != ''" >
            <v-col cols="12" md="3" class="pt-2">
            <v-text-field  v-model="salarypartialmaster_percentage" rounded outlined dense class="pt-1 mb-none pb-none" type="number"> </v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4"> 
                    <v-btn class="button" @click="set_working_days()">Set Percentage</v-btn>
                 </v-col>
                 </v-row>
                 <v-col cols="12" sm="12" md="12" v-if="finalPartialRegisterArray != ''"> 
            <v-simple-table fixed-header dense class="elevation-1" height="500px" >
                <thead>
                    <tr class="toolbar">
                        <td align="center" v-if="!salarypartialmaster_is_salary_release">
                            <label class="form-checkbox">
                                <input type="checkbox" v-model="selectAll" @click="select()" />
                                <i class="form-icon"></i>
                            </label>
                        </td>
                        <td align="center">Sr. No.</td>
                        <td align="center">Percentage</td>
                        <td align="center">Allocated Percentage</td>
                        <td align="center">Employee</td>
                        <td align="center">Working Days</td>
                        <td align="center">Salary Month</td>
                        <td align="center">Net Salary</td>
                        <td align="center">Partial Salary</td>
                        <td align="center">Paid Till Now</td>
                        <td align="center">Remaining</td>
                        <td align="center">Freezed Installment</td>
                        <td align="center">Release Salary</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(s, index) in finalPartialRegisterArray" :key="index">
                        <td v-if="!salarypartialmaster_is_salary_releasee">
                            <label class="form-checkbox">
                                <input type="checkbox" :value="s.reg_id" v-model="s.check_value" />
                                <i class="form-icon"></i>
                            </label>
                        </td>
                        <td align="center">{{ index + 1 }}</td>
                        <td align="center"><v-text-field v-model="s.allocate_percentage" rounded outlined dense class="pt-1 mb-none pb-none" type="number"> </v-text-field></td>
                        <td align="center">{{ s.percentage }}</td>
                        <td align="center">{{ s.emp_name }}</td>
                        <td align="center">{{ s.emp_working_days }}</td>
                        <td align="center">{{ s.sal_month }}</td>
                        <td align="center">{{ s.net_salary }}</td>
                        <td align="center">{{ s.currentinstallment }}</td>
                        <td align="center">{{ s.paidtillnow }}</td>
                        <td align="center">{{ s.remaining }}</td>
                        <td align="center"> 
                            <span v-if="s.isfreezed">
                                <v-icon small class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                            </span>
                            <span v-else>
                                <v-icon small class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                            </span>
                        <td align="center">
                            <span v-if="s.is_salary_release">
                                <v-icon small class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                            </span>
                            <span v-else>
                                <v-icon small class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </v-simple-table>
                 </v-col>
            <v-row justify="center" dense  v-if="finalPartialRegisterArray != '' && !salarypartialmaster_is_salary_release">
                <v-btn class="button" @click="partialSalaryCalculation(finalPartialRegisterArray)">Calculate Total Amount</v-btn>
                <v-btn class="button" @click="unfreezPartialSalaryCalculation(finalPartialRegisterArray)">Un-Freeze Partial Salary</v-btn>
            </v-row><br>
            <v-row justify="center" dense v-if="netTotalAmount!=null">
               <h2><strong>Total amount :: {{netTotalAmount}} /-</strong></h2> 
            </v-row>
             <v-row justify="center" dense  v-if="finalPartialRegisterArray != ''">
                <v-btn class="button" @click="savePartialSalary(finalPartialRegisterArray)">Save Partial Salary</v-btn>
                <v-btn class="button" @click="buttontype = 'Freezed';savePartialSalary(finalPartialRegisterArray)">Save & Freez Partial Salary</v-btn>
            </v-row><br>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                emppersonname: "",
                emptypename: null,
                snackbar_msg: "",
                color: "",
                snackbar: false,
                search: "",
                load: false,
                load_individual: false,
                show: false,
                empid: null,
                sal_mon_id: null,
                designation: null,
                employee_type: null,
                sal_month_list: [],
                employee_list: [],
                employee_type_list: [],
                designation_list: [],
                partial_salary_installment_list: [],
                partial_salary_installment: null,
                year_list: [],
                year: null,
                finalPartialRegisterArray: [],
                salarypartialmaster_name: null,
                salarypartialmaster_percentage: null,
                salarypartialmaster_id: null,
                salarypartialmaster_is_salary_release: null,
                netTotalAmount:null,
                selected: [],
                selectAll: false,
                error_employee:null,
                buttontype:null
            };
        },
        mounted() {
            axios
                .post("/Payroll/partialSalaryData")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.employee_list = res.data.employee_list;
                        this.employee_type_list = res.data.employee_type_list;
                        this.designation_list = res.data.designation_list;
                        this.year_list = res.data.year_list;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something Went Wrong");
                });
        },
        methods: {
             select() {
               // alert(this.selectAll)
                this.selected = [];
                for (let i in this.studentinfo) {
                    this.finalPartialRegisterArray[i].check_value = false;
                }
                if (!this.selectAll) {
                    for (let i in this.finalPartialRegisterArray) {
                        this.selected.push(this.finalPartialRegisterArray[i].reg_id);
                        this.finalPartialRegisterArray[i].check_value = true;
                    }
                }
                else{
                   for (let i in this.finalPartialRegisterArray) {
                        this.finalPartialRegisterArray[i].check_value = false;
                    } 
                }
            },
            unfreezPartialSalaryCalculation(finalPartialRegisterArray){
                 const data = {
                    finalPartialRegisterArray : finalPartialRegisterArray,
                    salarypartialmaster_id : this.salarypartialmaster_id
                }
                 axios
                    .post("/Payroll/unfreezPartialSalaryCalculation", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Salary Unfreezed Sucessfully...");
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    });
            },
            savePartialSalary(finalPartialRegisterArray){
                const data = {
                    buttontype : this.buttontype,
                    finalPartialRegisterArray : finalPartialRegisterArray,
                    salarypartialmaster_id : this.salarypartialmaster_id
                }
                 axios
                    .post("/Payroll/savePartialSalaryCalculation", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Salary Saved Sucessfully...");
                            this.getPartialSalaryCalculation()
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    });
            },
            partialSalaryCalculation(finalPartialRegisterArray){
                this.error_employee = null
                this.netTotalAmount = null
                const data = {
                    finalPartialRegisterArray : finalPartialRegisterArray,
                    salarypartialmaster_id : this.salarypartialmaster_id
                }
                 axios
                    .post("/Payroll/partialSalaryCalculation", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.error_employee = res.data.error_employee
                            this.netTotalAmount = res.data.netTotalAmount
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.snakbar_msg);
                            return;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    });
            },
            set_working_days(){
                for( var i = 0; i < this.finalPartialRegisterArray.length; i++)
                {
                    this.finalPartialRegisterArray[i].allocate_percentage = this.salarypartialmaster_percentage
                }
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getPartialSalaryCalculation() {
                this.finalPartialRegisterArray = []
                this.salarypartialmaster_name = null;
                this.salarypartialmaster_percentage = null;
                this.salarypartialmaster_id = null;
                this.salarypartialmaster_is_salary_release = null;
                this.error_employee = null
                this.netTotalAmount = null
                const data = {
                    sal_month: this.sal_mon_id,
                    employee_type: this.employee_type,
                    designation: this.designation,
                    employee: this.empid,
                    partial_salary_installment: this.partial_salary_installment,
                };
                axios
                    .post("/Payroll/getPartialSalaryCalculation", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.finalPartialRegisterArray = res.data.finalPartialRegisterArray;
                            this.salarypartialmaster_name = res.data.salarypartialmaster_name;
                            this.salarypartialmaster_percentage = res.data.salarypartialmaster_percentage;
                            this.salarypartialmaster_id = res.data.salarypartialmaster_id;
                            this.salarypartialmaster_is_salary_release = res.data.salarypartialmaster_is_salary_release;
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.snakbar_msg);
                            return;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    });
            },
            partialSalaryMasterData() {
                const data = {
                    sal_month: this.sal_mon_id,
                };
                axios
                    .post("/Payroll/partialSalaryMasterData", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.partial_salary_installment_list = res.data.partial_salary_installment_list;
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.snakbar_msg);
                            return;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    });
            },

            partialSalaryMonthData() {
                const data = {
                    year: this.year,
                };
                axios
                    .post("/Payroll/partialSalaryMonthData", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.sal_month_list = res.data.sal_month_list;
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.snakbar_msg);
                            return;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    });
            },
        },
    };
</script>
<style scoped>
    thead {
        font-weight: bold !important;
    }
    th {
        font-weight: bold !important;
    }
    tr,
    td,
    th {
        border: 1px solid black;
        /* text-align: center; */
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid black;
        border: 1px solid black;
        font-size: small;
    }
    td {
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        /* text-align: center; */
        font-size: small;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
</style>
